import { useState } from "react";

import { Mail, MessageCircle } from "lucide-react";

import { SITE_CONTACT } from "../seo/site";

import { FeedbackModal } from "./FeedbackModal";

import type { CanvaschoolApi } from "../api/client";

/**
 * The 의견·요청 strip under the class and canvas lists: the same text box
 * as the editor's button, plus the help mail address for anything longer.
 */
export const FeedbackContact = ({
  api,
}: {
  api: Pick<CanvaschoolApi, "sendClientReport" | "listMyClientReports">;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <aside className="canvaschool-feedback-contact" aria-label="의견·요청">
      <p className="canvaschool-feedback-contact-text">
        바라는 기능, 불편한 점, 오류까지 무엇이든 알려 주세요. 모두 읽고
        반영합니다.
      </p>
      <div className="canvaschool-feedback-contact-actions">
        <button
          type="button"
          className="canvaschool-btn-secondary"
          onClick={() => setOpen(true)}
        >
          <MessageCircle size={16} aria-hidden="true" />
          의견·요청 보내기
        </button>
        <a href={`mailto:${SITE_CONTACT}`}>
          <Mail size={16} aria-hidden="true" />
          {SITE_CONTACT}
        </a>
      </div>
      {open && (
        <FeedbackModal
          source="USER_REPORT"
          api={api}
          onClose={() => setOpen(false)}
        />
      )}
    </aside>
  );
};
